// extracted by mini-css-extract-plugin
export var hidden = "_4v-1";
export var leftPanel = "_4v-2";
export var readonlyInspector = "_4v-3";
export var rightPanel = "_4v-0";